import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
  selector: 'app-seat-availability',
  templateUrl: './seat-availability.component.html',
  styleUrls: ['./seat-availability.component.scss']
})
export class SeatAvailabilityComponent implements OnInit {

  @Output() childEvent = new EventEmitter();
  @Input() seats: any;
  @Input() img: any;
  constructor() { }

  ngOnInit(): void {}

  openModal(seatInfo): void {
    this.childEvent.emit(seatInfo);
  }

}
